import { Container, Row, Col } from "react-bootstrap";
// import email from "../assets/img/email.svg";
// import github from "../assets/img/github.svg";
// import linkedin from "../assets/img/linkedin.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            {/* <img src={}></img> */}
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            {/* <div className="social-icon">
              <a href="mailto:shirenekboyd@gmail.com" alt="email link">
                <img src={email} alt="email link" />
              </a>
              <a
                href="https://github.com/shirenekboyd"
                alt="github link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={github} alt="github link" />
              </a>
              <a
                href="https://www.linkedin.com/in/shirene-boyd"
                alt="linkedin link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedin} alt="linkedin link" />
              </a>
            </div> */}
            {/* <p>CopyRight 2023. All Rights Reserved</p> */}
            <p>&copy; 2023 Shirene K Boyd. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
